const DEFAULT_TITLE = 'GameNostic — Crash Analytics & Monitoring for Unreal Engine | No SDKs. 5 Min Setup.';
const DEFAULT_DESCRIPTION =
    'The crash reporting tool built for Unreal Engine. Catch 99% of crashes on PC, PS5, Xbox, Switch & mobile. No native SDKs. No build pipeline changes. Real-time session monitoring, AI crash grouping, Slack & Discord alerts. Free during beta.';

const JSONLD_SCRIPT_ID = 'page-jsonld';

/** Inject (or replace) a JSON-LD <script> tag in <head> for the current page. */
export function setJsonLd(schema: object): void {
    let el = document.getElementById(JSONLD_SCRIPT_ID) as HTMLScriptElement | null;
    if (!el) {
        el = document.createElement('script');
        el.id = JSONLD_SCRIPT_ID;
        el.type = 'application/ld+json';
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);
}

/** Remove the page-level JSON-LD <script> tag injected by setJsonLd. */
export function clearJsonLd(): void {
    document.getElementById(JSONLD_SCRIPT_ID)?.remove();
}

export function setPageMeta(title: string, description?: string, canonical?: string): void {
    document.title = title;

    const descEl = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (descEl) descEl.setAttribute('content', description ?? DEFAULT_DESCRIPTION);

    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);

    const ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description ?? DEFAULT_DESCRIPTION);

    const twTitle = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);

    const twDesc = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description ?? DEFAULT_DESCRIPTION);

    const canonEl = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonEl) canonEl.setAttribute('href', canonical ?? 'https://gamenostic.gg/');

    const ogUrl = document.querySelector<HTMLMetaElement>('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonical ?? 'https://gamenostic.gg/');
}

export function resetPageMeta(): void {
    setPageMeta(DEFAULT_TITLE, DEFAULT_DESCRIPTION, 'https://gamenostic.gg/');
    clearJsonLd();
}
